import "@js/sceneInit.js";
import "@js/cursorAnim.js";
document.addEventListener('DOMContentLoaded', async function() {
  await import ("@js/iconAnim.js");
  await import("@js/scroll.js");
  // await import("@js/projectScroll.js"); // Uncomment if you need this for other pages
  await import("@js/slider.js");
  await import("@js/mailto.js");
});
